import styled from 'styled-components';

export const Container = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;

// Estilos com Styled Components
export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const PageButton = styled.button<{ active?: boolean }>`
  position: relative;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 1rem;
  border-radius: 50%;
  color: #fff;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: 0.3s ease-in-out;
  background: ${({ active, theme }) =>
    active ? theme.colors.muted : theme.colors.muted}20;
  animation: ${({ active }) =>
    active ? 'pulseAnimationCss 2s infinite' : 'unset'};
  font-size: 1rem;
  font-weight: bold;
  border: 1px solid ${({ theme }) => theme.colors.muted}10;

  &.current {
    animation: pulseAnimationCss 2s infinite;
  }

  &.correct {
    background: #03bb85;
    color: #fff !important;
  }

  &.incorrect {
    background: #e74c3c;
    color: #fff !important;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  > svg {
    scale: 2;
  }
`;

export const Input = styled.input`
  width: 50px;
  padding: 10px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.muted}40;
  background: ${({ theme }) => theme.input.background};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
`;

export const TotalItems = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.muted};
`;
